import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { Alert } from 'react-bootstrap-5';
import { isEmpty } from 'lodash';

export default function Errors({
  className,
  description = 'The following errors prevented the form from saving:',
  errors,
}) {
  if (!errors || isEmpty(errors)) {
    return null;
  }

  return (
    <Alert className={classNames(className)} variant="warning">
      <b>{description}</b>
      {errors.map(error => (
        <div key={error}>
          {error}
        </div>
      ))}
    </Alert>
  );
}

Errors.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
};
